var json = {
  man: {
    title: "This is a man",
    image_url: "image url",
    next_step: {
      pants: {
        title: "This is a man - pants",
        image_url: "image url",
        next_step: {
          28: {
            title: "This is a man - pants - 28",
            image_url: "image url",
            next_step: {
              product: "HANDLE OF PRODUCT",
            },
          },
          29: {
            title: "This is a man - pants - 29",
            image_url: "image url",
            next_step: {
              product: "HANDLE OF PRODUCT",
            },
          },
        },
      },
      shirt: {
        title: "This is a man - shirt",
        image_url: "image url",
        next_step: {
          s: {
            title: "This is a man - shirt - s",
            image_url: "image url",
            next_step: {
              product: "HANDLE OF PRODUCT",
            },
          },
          m: {
            title: "This is a man - shirt - m",
            image_url: "image url",
            next_step: {
              product: "HANDLE OF PRODUCT",
            },
          },
        },
      },
    },
  },
  woman: {
    title: "This is a woman",
    image_url: "image url",
    next_step: {
      dress: {
        title: "This is a woman - dress",
        image_url: "image url",
        next_step: {
          8: {
            title: "This is a woman - dress - 8",
            image_url: "image url",
            next_step: {
              product: "HANDLE OF PRODUCT",
            },
          },
          10: {
            title: "This is a woman - dress - 10",
            image_url: "image url",
            next_step: {
              product: "HANDLE OF PRODUCT",
            },
          },
        },
      },
      skirt: {
        title: "This is a woman - skirt",
        image_url: "image url",
        next_step: {
          xs: {
            title: "This is a woman - skirt - xs",
            image_url: "image url",
            next_step: {
              product: "HANDLE OF PRODUCT",
            },
          },
          l: {
            title: "This is a woman - skirt - l",
            image_url: "image url",
            next_step: {
              product: "HANDLE OF PRODUCT",
            },
          },
        },
      },
    },
  },
};

let step1 = "";
let step2 = "";

function renderDataStep(item, step) {
  $("#multi_step").append("<li> STEP " + step + " </li>");
  let dataStep = json[item]["next_step"];
  $.each(dataStep, function (data, v) {
    $("#multi_step").append(
      "<li><button data-value=" +
        data +
        " data-step-0" +
        step +
        ">" +
        v.title +
        "</button></li>"
    );
  });
}

$("#multi_step").append("<li> STEP 1 </li>");
$.each(json, function (data, v) {
  $("#multi_step").append(
    "<li><button data-value=" +
      data +
      " data-step-01>" +
      v.title +
      "</button></li>"
  );
});

$("button[data-step-01]").on("click", function () {
  step1 = $(this).attr("data-value");
  renderDataStep(step1, "2");
});

$("button[data-step-02]").on("click", function () {
  step2 = $(this).attr("data-value");
  renderDataStep(step2, "3");
});


////
// console.log("testt");
// fetch(window.Shopify.routes.root + 'products/sticker-l.js')
//   .then(response => response.json())
//   .then(product => {
//     console.log("product title1");
//     console.log("product title: ", product.title);
//     alert('The title of this product is ' + product.title);
//   });

// fetch(window.Shopify.routes.root + 'products/sticker-l.js')
//   .then(response => response.json())
//   .then(product => alert('The title of this product is ' + product.title));


console.log("testt2");
fetch('/products/sticker-l?view=test')
.then(response => response.text())
.then(html => {
  console.log("test2");
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const title = doc.querySelector('.label-nano')?.innerText;
  console.log("title:", title);
  // alert('The title of this product is ' + title);
})
.catch(error => {
  console.error('Error:', error);
});
